export default __webpack_public_path__ + "static/media/ROM CLASS-7_SYLLABUS_2025-26.5cf2e740.pdf";